import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/sam/stop-network'

const BaseStopNetworkAreaRoutes = {
  route: baseRoute,

  Show: {
    route: '/:serviceAreaId',

    Overview: {
      route: '/overview',
      More: {
        route: '/more',
      },
      RecentlyDeactivated: {
        route: '/recently-deactivated',
      },
      StoppingAccuracy: {
        route: '/stopping-accuracy',
      },
    },
    Import: {
      route: '/import',
    },

    Stops: {
      route: '/stops',

      New: {
        route: '/new',
      },

      Show: {
        route: '/:stopId',

        Deactivations: {
          route: '/deactivations',
          Show: {
            route: '/:deactivationId',
          },
          New: {
            route: '/new',
          },
        },

        Areas: {
          route: '/areas',
        },

        Settings: {
          route: '/settings',
        },

        Statistics: {
          route: '/statistics',
        },
      },
    },

    Filters: {
      route: '/filter',
      Results: {
        route: '/results',
      },
    },

    Areas: {
      route: '/areas',

      New: {
        route: '/new',
      },

      Show: {
        route: '/:areaId',

        Deactivations: {
          route: '/deactivations',
          Show: {
            route: '/:deactivationId',
          },
          New: {
            route: '/new',
          },
        },

        Settings: {
          route: '/settings',
        },

        StopsWithinArea: {
          route: '/stops',
        },
      },
    },

    LineService: {
      route: '/line-service',

      New: {
        route: '/new',
      },

      Show: {
        route: '/:lineServiceId',

        Edit: {
          route: '/edit',
        },
      },
    },

    StopList: {
      route: '/stops-list',
      Show: {
        route: '/:stopId',

        Deactivations: {
          route: '/deactivations',
          Show: {
            route: '/:deactivationId',
          },
          New: {
            route: '/new',
          },
        },

        Areas: {
          route: '/areas',
        },

        Settings: {
          route: '/settings',
        },

        Statistics: {
          route: '/statistics',
        },
      },
    },

    AreasList: {
      route: '/areas-list',

      Show: {
        route: '/:areaId',

        Deactivations: {
          route: '/deactivations',
          Show: {
            route: '/:deactivationId',
          },
          New: {
            route: '/new',
          },
        },

        Settings: {
          route: '/settings',
        },

        StopsWithinArea: {
          route: '/stops',
        },
      },
    },
  },
}

export const StopNetworkAreaRoutes = transformRoutes(BaseStopNetworkAreaRoutes)

export const StopNetworkAreaBasePaths = transformRoutes({
  ...BaseStopNetworkAreaRoutes,
  route: '',
})
